import moment from 'moment';

//
import template from './feedback-history.html';

const statusCssClasses = {
  pending: 'fa fa-spinner fa-pulse fa-md pending-icon',
  completed: 'fa fa-check succeeded-icon fa-md ',
  failed: 'fa fa-times failed-icon fa-md',
};

class CommandsFeedbackHistoryController {
  constructor(dashboardCommandsService) {
    'ngInject';

    this.commandService = dashboardCommandsService;

    this.statusClasses = {
      pending: statusCssClasses.pending,
      aborted: statusCssClasses.failed,
      completed: statusCssClasses.completed,
      rejected: statusCssClasses.failed,
      acknowledged: statusCssClasses.pending,
      pendingAbort: statusCssClasses.failed,
    };
  }

  $onInit() {
    this.statusMap = this.commandService.commandStatusMap();
  }

  $onDestroy() {}

  getExpectedDate(date) {
    return moment(date).add(3, 'm').toDate();
  }
}

export default {
  template,
  controller: CommandsFeedbackHistoryController,
  controllerAs: 'vm',
  bindings: {
    history: '<',
    loading: '<',
    valuesLookup: '<',
  },
};
